export const ReportIcon = "./assets/icons/report.svg";
export const PageIcon = "./assets/icons/page.png";
export const BookmarkIcon = "./assets/icons/bookmark.svg";
export const DashboardIcon = "./assets/icons/dashboard.svg";
